import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { RootState } from './rootState';
import type { AppDispatch } from './store';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
